import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import socket from '@/socket/socket';
import { updateStateOnUpdateBookById, updateStateOnAddBookById, updateStateOnDeleteBookById } from '@/redux/actions';

export const useBookRealtime = ({ customerId }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!customerId) {
            return;
        }

        const handleBookChanged = ({ id, action }) => {
            console.log('<<<Book changed:', id, customerId, action);

            if (action === 'UPDATE') {
                dispatch(updateStateOnUpdateBookById(id));
            } else if (action === 'CREATE') {
                dispatch(updateStateOnAddBookById(id));
            } else if (action === 'DELETE') {
                dispatch(updateStateOnDeleteBookById(id));
            }
        };

        socket.on('book:changed', handleBookChanged);

        return () => {
            socket.off('book:changed', handleBookChanged);
        };

    }, [customerId, dispatch]);
};